import { render, staticRenderFns } from "./TheArticleToolbar.vue?vue&type=template&id=7a672209&"
import script from "./TheArticleToolbar.vue?vue&type=script&lang=js&"
export * from "./TheArticleToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports